/**
 * @function addSizeString
 * @description Temporary return original size until images sizes are fixed ~This function returns a new URL that contains the size string~
 * @param url - The url string. This could be something like 'https://url/images/year/month/image.png'.
 * @param size - The size string. This could be something like 'w600'.
 * @returns - The new URL (e.g., 'https://url/images/size/w600/year/month/image.png')
 */
export const addSizeString = (url: string, size: string): string => {
  /** Uncomment this once image sizes are fixed in Ghost
  const urlParts = url.split('/')

  const insertPosition = urlParts.findIndex((part) => /\d{4}/.test(part))

  if (insertPosition !== -1) {
    urlParts.splice(insertPosition, 0, 'size', size)
  }

  const newUrl = urlParts.join('/')
  return newUrl
   */

  return url
}
